---
title: "Vibration Test Complete"
date: 2026-03-10
category: "Engineering"
---

The Dynamic Test Model has completed vibration testing! The assembly survived sine vibe, and random +3db above the full launch loads in all axes, validating the structural design, our workmanship, and providing ground truth for model correlation.

![MSM mounted on the shaker table for vibration testing](/images/blog-vibration-test/vibration-test-1.jpg)

## Test Setup

The telescope was bolted to the shaker via its flight mounting interface, with 16 triaxial accelerometers placed at key structural nodes — the optical bench, the primary mirror surrogate, the secondary mirror tower, the fast steering mirror, and elsewhere. The telescope has polka-dots (retroreflective stickers) on it for both high-speed-video tracking during vibe, and as references for laser scan metrology pre and post to look for gross slips and movements in the structure. None detected!

The instrumentation captured the structure's response across the full frequency range we expect to see during launch.

## What's Next

With vibration data in hand, we can correlate our finite element models against measured response and close the loop on structural margin. Then, we design and build Rev2.
